var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"ripple",rawName:"v-ripple",value:('rgb(255 139 0 / 20%)'),expression:"'rgb(255 139 0 / 20%)'"}],ref:"ref",staticClass:"button-action",class:{ 'disabled': _vm.isDisabled }},[_c('i',{class:_vm.data.icon}),_c('p',[_vm._v(_vm._s(_vm.data.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }